var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 45,
    fill: "currentColor",
    viewBox: "0 0 54 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.716 15.083A2.925 2.925 0 0 0 24.633 18h26.25a2.925 2.925 0 0 0 2.917-2.917 2.925 2.925 0 0 0-2.917-2.916h-26.25a2.925 2.925 0 0 0-2.916 2.916ZM53.8 3.417a2.925 2.925 0 0 1-2.917 2.916h-26.25a2.925 2.925 0 0 1-2.916-2.916A2.925 2.925 0 0 1 24.633.5h26.25A2.925 2.925 0 0 1 53.8 3.417ZM33.383 26.75a2.925 2.925 0 0 1 2.917-2.917h14.583A2.925 2.925 0 0 1 53.8 26.75a2.925 2.925 0 0 1-2.917 2.917H36.3a2.925 2.925 0 0 1-2.917-2.917Zm-23.362-6.212L7.95 18.466a2.906 2.906 0 0 0-4.113 0l-2.07 2.07a2.905 2.905 0 0 0 0 4.113l2.07 2.07 6.184-6.182Zm2.07 2.07 15.05 15.05c.263.263.409.613.409 1.021v4.113c0 .816-.642 1.458-1.459 1.458H21.98c-.38 0-.758-.146-1.02-.438L5.91 28.762l6.183-6.154Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/blog.18b8caa7298f009fe5737555be0d3c7b.svg";
export { ForwardRef as ReactComponent };